goog.provide('el8.ext.Form');

goog.require('el8.model.base');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.NewInfoField');


el8.ext.Form = function(spec) {
    this._name = spec.name;
    el8.uiwidget.Form.apply(this, arguments);
};
el8.ext.Form.inheritsFrom(el8.uiwidget.Form);

el8.ext.Form.prototype._createInfoField = function(spec) {
    return new el8.uiwidget.NewInfoField(spec);
};
